<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple-light">
          <span>书目库存更新记录</span>
        </div>
      </el-col>
    </el-row>
    <el-table :data="tableData" stripe border style="width: 100%">
      <!-- <el-table-column prop="supWarehouseId_dictText" label="供货商"></el-table-column> -->
      <el-table-column prop="batchStatus" label="处理状态">
        <template slot-scope="scope">
          <el-tag size="medium" :type="scope.row.batchStatus == '1' ? 'success' : scope.row.batchStatus == '2' ? 'danger' : 'info'">
            {{ scope.row.batchStatus == '1' ? '处理完成' : scope.row.batchStatus == '2' ? '处理失败' : '未处理' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="fileName" label="文件名"></el-table-column>
      <el-table-column prop="fileSize" label="文件大小">
        <template slot-scope="scope">
          {{ (scope.row.fileSize / 1024.0 / 1024.0).toFixed(1) + 'M' }}
        </template>
      </el-table-column>
      <el-table-column prop="dataSize" label="数据总量"></el-table-column>
      <el-table-column prop="successDataSize" label="成功数量"></el-table-column>
      <el-table-column prop="usageTime" label="最终耗时">
        <template slot-scope="scope">
          {{ scope.row.usageTime > 60 ? (parseInt(scope.row.usageTime / 60) + '分' + (scope.row.usageTime % 60 == 0 ? '' : scope.row.usageTime % 60 + "秒")) : (scope.row.usageTime + '秒') }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="remark" label="更新日志" show-overflow-tooltip="true"></el-table-column> -->
      <el-table-column prop="createTime" label="上传时间"></el-table-column>
    </el-table>
    <el-row align="bottom">
      <el-col :span="16">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          @prev-click="handlePrevClick"
          @next-click="handleNextClick"
          :current-page.sync="page.pageNo" 
          :page-size="page.pageSize" 
          :total="page.total"
          layout="total, prev, pager, next"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getAction } from "../../api/index";
import { mapGetters } from "vuex";
export default {
  name: "bookLog",
  data() {
    return {
      tableData: [],
      textarea: "",
      isdefault: false,
      url: {
        list: "/provider/listUpdateStockWh",
      },
      page:{
        pages: 0, //总页数
        pageNo: 1, //当前页码
        pageSize: 10, //一页显示的数量  必须是奇数
        total: 0, //数据的数量
      }
    };
  },
  mounted() {},
  computed: {
    ...mapGetters(["isNaName"]),
  },
  created() {
    this.list();
  },
  methods: {
    list() {
      const that = this
      var params={
        pageNo: that.page.pageNo,
        pageSize: that.page.pageSize,
        whid: this.$store.state.userInfo.id,
      }
      getAction(this.url.list, params).then((res) => {
        if (res.data.success) {
          var l = res.data.result.records
          that.tableData = l
          that.page.total = res.data.result.total
          that.page.pages = res.data.result.pages
        }
      });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page.pageNo = val
      this.list()
    },
    handlePrevClick(val) {
      console.log(`上一页: ${val}`);
    },
    handleNextClick(val) {
      console.log(`下一页: ${val}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
  margin-top: 1%;
  font-size: 14px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.bg-purple-light {
  line-height: 36px;
}
.el-cascader {
  display: block;
}
</style>
